<template>
	<input
		ref="input"
		type="text"
		:name="name"
		v-bind="attributes"
		:value="currentValue"
		@input="handleInput"
		@change="handleChange"
		@focus="handleFocus"
		@blur="handleBlur"
	>
</template>

<script>
import basefield from '../../mixins/basefield'

export default {
	name: 'formit-text',
	mixins: [basefield],
}
</script>



// WEBPACK FOOTER //
// node_modules/vue-formit-fields/src/components/text-field/text-field.vue